const Wrapper = ({children, reverse}) => {
    return <div className={`input-row${reverse ? " reverse" : ""}`}>{children}</div>
}
export default Wrapper